<template>
  <header class="about-header p-4">
    <h1 class="fall-down">YCLA</h1>
    <p class="image-fade-in">
      Propulsez votre entreprise vers l'excellence<br />
      en offrant à vos équipes des vidéos captivantes et une application de
      mobile learning
    </p>
  </header>
  <div class="img-header mt-1 mt-lg-5 mt-lg-2">
    <img
      src="@/assets/pictures/micro-learning-01.webp"
      alt="visual on iphone"
    />
  </div>
</template>

<script>
export default {
  name: "AboutHeader",
};
</script>

<style lang="scss" scoped>
.about-header {
  //height: 20vh;
  /*background-image: url("@/assets/pictures/ia-about.webp");
  background-size: contain;*/
  /*@media screen and (min-width: 992px) {
    background-size: cover;
  }*/
  /*background-repeat: no-repeat;
  background-position: center center;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & h1 {
    color: $color-primary;
    font-size: 3em;
    text-align: center;
  }
  & p {
    color: $color-text;
    font-size: 1.3em;
    text-align: center;
    & .fake-space {
      margin-left: 8px;
    }
  }
}
.img-header {
  display: flex;
  justify-content: center;
  align-items: center;
  & img {
    width: 400px;
    overflow: hidden;
  }
}
</style>
